export default [
  {
    path: "/settings",
    component: () => import("@/components/General/DashboardHeader.vue"),
    children: [
      {
        path: "/settings",
        name: "settings",
        component: () => import("./Settings.vue"),
      },
    ],
  },
];
